import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { Product } from "src/app/modals/product.model";
import { CartItem } from "src/app/modals/cart-item";
import { CartService } from "../services/cart.service";
import { SidebarMenuService } from "../sidebar/sidebar-menu.service";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Route } from "@angular/compiler/src/core";
import { Router } from "@angular/router";
import { ItemsService } from "src/app/services/items.service";
import { Observable } from "rxjs";
import { ObservService } from "src/app/services/observ.service";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.sass"],
})
export class HeaderComponent implements OnInit {
  public sidenavMenuItems: Array<any>;

  public currencies = ["USD", "EUR"];
  public currency: any;
  public flags = [
    { name: "English", image: "assets/images/flags/gb.svg" },
    { name: "German", image: "assets/images/flags/de.svg" },
    { name: "French", image: "assets/images/flags/fr.svg" },
    { name: "Russian", image: "assets/images/flags/ru.svg" },
    { name: "Turkish", image: "assets/images/flags/tr.svg" },
  ];
  public flag: any;

  products: Product[];

  indexProduct: number;
  shoppingCartItems: CartItem[] = [];
  fbBuscador: FormGroup;
  resultBusquedaList: any[] = [];
  cartItems: any[] = [];
  constructor(
    private cartService: CartService,
    private fb: FormBuilder,
    private router: Router,
    private itemServices: ItemsService,
    public observService: ObservService
  ) {
    this.cartService
      .getItems()
      .subscribe(
        (shoppingCartItems) => (this.shoppingCartItems = shoppingCartItems)
      );
  }

  ngOnInit() {
    this.currency = this.currencies[0];
    this.flag = this.flags[0];
    this.buildForm();
    window.scrollTo(0, 0);
  }

  buildForm() {
    this.fbBuscador = this.fb.group({
      criterio: [""],
    });
  }

  public changeCurrency(currency) {
    this.currency = currency;
  }
  public changeLang(flag) {
    this.flag = flag;
  }

  seleccionarItem() {
    let paramNomItem = {
      param1: "",
      param2: "",
      param3: "",
    };
    sessionStorage.setItem("paramFilter", JSON.stringify(paramNomItem));
    this.router.navigate([
      "/home/products",
      0,
      this.fbBuscador.get("criterio").value.length == 0 ? '0' : this.fbBuscador.get("criterio").value,
      0,
      "TODAS",
      0,
      0,
      1,
    ]);
  }

  buscarItems() {
    if (this.fbBuscador.get("criterio").value.length >= 3) {
      let param: any;
      if (!isNaN(this.fbBuscador.get("criterio").value)) {
        param = [
          {
            keyparam: "CodigoBarras",
            valueparam: this.fbBuscador.get("criterio").value,
          },
        ];
      } else {
        param = [
          {
            keyparam: "NombreItm",
            valueparam: this.fbBuscador.get("criterio").value,
          },
        ];
      }
      this.itemServices.itemsList(param).subscribe((res: any) => {
        this.resultBusquedaList = res;
      });
    }
  }
  public getTotal(): Observable<number> {
    return this.cartService.getTotalAmount();
  }
  public removeItem(item: any) {
    this.cartService.removeFromCart(item);
  }
  
}
